import React from 'react';
import { ArrowLeft, Building2, Phone, Mail, Globe, CreditCard, Scale, FileText } from 'lucide-react';
import { Link } from 'react-router-dom';

const ImpressumPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-600 to-orange-500 text-white py-12">
        <div className="max-w-4xl mx-auto px-4">
          <Link 
            to="/" 
            className="inline-flex items-center text-white/80 hover:text-white mb-4 transition-colors"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Zurück zur Startseite
          </Link>
          <h1 className="text-4xl font-bold">Impressum</h1>
          <p className="text-blue-100 mt-2">Angaben gemäß § 5 TMG</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="space-y-8">
          
          {/* Company Info */}
          <section className="bg-white rounded-2xl shadow-lg p-8 border border-gray-200">
            <div className="flex items-center gap-3 mb-6">
              <div className="bg-blue-100 p-3 rounded-xl">
                <Building2 className="h-6 w-6 text-blue-600" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900">Unternehmensangaben</h2>
            </div>
            
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <h3 className="font-semibold text-gray-700 mb-2">Firmenname</h3>
                <p className="text-gray-900 text-lg">Dom's Pfotenexpress</p>
              </div>
              
              <div>
                <h3 className="font-semibold text-gray-700 mb-2">Inhaber</h3>
                <p className="text-gray-900">Dominique Ewerling</p>
              </div>
              
              <div>
                <h3 className="font-semibold text-gray-700 mb-2">Anschrift</h3>
                <p className="text-gray-900">
                  Sternstraße 1<br />
                  58089 Hagen<br />
                  Deutschland
                </p>
              </div>
              
              <div>
                <h3 className="font-semibold text-gray-700 mb-2">Unternehmensform</h3>
                <p className="text-gray-900">
                  Einzelunternehmen
                </p>
              </div>
            </div>
          </section>

          {/* Contact */}
          <section className="bg-white rounded-2xl shadow-lg p-8 border border-gray-200">
            <div className="flex items-center gap-3 mb-6">
              <div className="bg-orange-100 p-3 rounded-xl">
                <Phone className="h-6 w-6 text-orange-600" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900">Kontakt</h2>
            </div>
            
            <div className="grid md:grid-cols-3 gap-6">
              <div className="flex items-start gap-3">
                <Phone className="h-5 w-5 text-blue-600 mt-1" />
                <div>
                  <h3 className="font-semibold text-gray-700 mb-1">Telefon</h3>
                  <a href="tel:+4915739696942" className="text-blue-600 hover:text-blue-800">
                    01573 969 69 42
                  </a>
                </div>
              </div>
              
              <div className="flex items-start gap-3">
                <Mail className="h-5 w-5 text-blue-600 mt-1" />
                <div>
                  <h3 className="font-semibold text-gray-700 mb-1">E-Mail</h3>
                  <a href="mailto:doms.pfotenexpress@gmail.com" className="text-blue-600 hover:text-blue-800">
                    doms.pfotenexpress@gmail.com
                  </a>
                </div>
              </div>
              
              <div className="flex items-start gap-3">
                <Globe className="h-5 w-5 text-blue-600 mt-1" />
                <div>
                  <h3 className="font-semibold text-gray-700 mb-1">Website</h3>
                  <a href="https://booking-hub-435.preview.emergentagent.com" className="text-blue-600 hover:text-blue-800">
                    www.doms-pfotenexpress.de
                  </a>
                </div>
              </div>
            </div>
          </section>

          {/* Bank Details */}
          <section className="bg-white rounded-2xl shadow-lg p-8 border border-gray-200">
            <div className="flex items-center gap-3 mb-6">
              <div className="bg-green-100 p-3 rounded-xl">
                <CreditCard className="h-6 w-6 text-green-600" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900">Bankverbindung</h2>
            </div>
            
            <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl p-6 border border-green-200">
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <h3 className="font-semibold text-gray-700 mb-1">Kontoinhaber</h3>
                  <p className="text-gray-900 font-medium">Dominique Frank Ewerling</p>
                </div>
                
                <div>
                  <h3 className="font-semibold text-gray-700 mb-1">Bank</h3>
                  <p className="text-gray-900">Commerzbank Hagen</p>
                </div>
                
                <div className="md:col-span-2">
                  <h3 className="font-semibold text-gray-700 mb-1">IBAN</h3>
                  <p className="text-gray-900 font-mono text-lg tracking-wider">DE09 4504 0042 0340 5859 00</p>
                </div>
              </div>
            </div>
          </section>

          {/* Tax Info */}
          <section className="bg-white rounded-2xl shadow-lg p-8 border border-gray-200">
            <div className="flex items-center gap-3 mb-6">
              <div className="bg-purple-100 p-3 rounded-xl">
                <FileText className="h-6 w-6 text-purple-600" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900">Steuerliche Angaben</h2>
            </div>
            
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <h3 className="font-semibold text-gray-700 mb-1">Steuernummer</h3>
                <p className="text-gray-900 font-mono">321/5063/2428</p>
              </div>
              
              <div>
                <h3 className="font-semibold text-gray-700 mb-1">Zuständiges Finanzamt</h3>
                <p className="text-gray-900">Finanzamt Hagen</p>
              </div>
              
              <div className="md:col-span-2">
                <h3 className="font-semibold text-gray-700 mb-1">Umsatzsteuer</h3>
                <p className="text-gray-900">Gemäß §19 UStG wird keine Umsatzsteuer berechnet (Kleinunternehmerregelung)</p>
              </div>
            </div>
          </section>

          {/* Veterinary Authority */}
          <section className="bg-white rounded-2xl shadow-lg p-8 border border-gray-200">
            <div className="flex items-center gap-3 mb-6">
              <div className="bg-teal-100 p-3 rounded-xl">
                <Building2 className="h-6 w-6 text-teal-600" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900">Zuständige Behörde</h2>
            </div>
            
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <h3 className="font-semibold text-gray-700 mb-1">Zuständiges Veterinäramt</h3>
                <p className="text-gray-900">Veterinäramt Hagen</p>
              </div>
              
              <div>
                <h3 className="font-semibold text-gray-700 mb-1">Ansprechpartnerin</h3>
                <p className="text-gray-900">Frau Dr. Piepenbrink</p>
              </div>
              
              <div className="flex items-start gap-3">
                <Phone className="h-5 w-5 text-teal-600 mt-1" />
                <div>
                  <h3 className="font-semibold text-gray-700 mb-1">Telefon</h3>
                  <a href="tel:+492331207257" className="text-blue-600 hover:text-blue-800">
                    02331 / 207-2575
                  </a>
                </div>
              </div>
            </div>
          </section>

          {/* Dispute Resolution */}
          <section className="bg-white rounded-2xl shadow-lg p-8 border border-gray-200">
            <div className="flex items-center gap-3 mb-6">
              <div className="bg-yellow-100 p-3 rounded-xl">
                <Scale className="h-6 w-6 text-yellow-600" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900">Streitschlichtung</h2>
            </div>
            
            <div className="space-y-4 text-gray-700">
              <p>
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
                <a 
                  href="https://ec.europa.eu/consumers/odr/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:text-blue-800 underline"
                >
                  https://ec.europa.eu/consumers/odr/
                </a>
              </p>
              
              <p>
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </div>
          </section>

          {/* Liability */}
          <section className="bg-white rounded-2xl shadow-lg p-8 border border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Haftungsausschluss</h2>
            
            <div className="space-y-6 text-gray-700">
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Haftung für Inhalte</h3>
                <p>
                  Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten 
                  nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als 
                  Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde 
                  Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige 
                  Tätigkeit hinweisen.
                </p>
              </div>
              
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Haftung für Links</h3>
                <p>
                  Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen 
                  Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. 
                  Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber 
                  der Seiten verantwortlich.
                </p>
              </div>
              
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Urheberrecht</h3>
                <p>
                  Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen 
                  dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art 
                  der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen 
                  Zustimmung des jeweiligen Autors bzw. Erstellers.
                </p>
              </div>
            </div>
          </section>

          {/* Last Update */}
          <div className="text-center text-gray-500 text-sm">
            <p>Stand: Januar 2026</p>
          </div>
        </div>
      </div>

      {/* Simple Footer */}
      <div className="bg-gray-900 text-white py-6">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <p className="text-gray-400">
            © {new Date().getFullYear()} Dom's Pfotenexpress - Alle Rechte vorbehalten
          </p>
          <div className="flex justify-center gap-6 mt-3">
            <Link to="/datenschutz" className="text-gray-400 hover:text-white transition-colors">
              Datenschutz
            </Link>
            <Link to="/agb" className="text-gray-400 hover:text-white transition-colors">
              AGB
            </Link>
            <Link to="/" className="text-gray-400 hover:text-white transition-colors">
              Startseite
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImpressumPage;
